<template>
  <div class="GlobalTable">
    <div class="button_top">
      <div class="radiobtn">
        <div class="faultBtn">
          <div :class="auditStatus === null ? 'active' : 'none'" @click="btnClick(null)">
            全部({{ numView.allNum || 0 }}台)
          </div>
          <div :class="auditStatus === '03' ? 'active' : 'none'" @click="btnClick('03')">
            售卖中({{ numView.sellingNum || 0 }}台)
          </div>
          <div :class="auditStatus === '00' ? 'active' : 'none'" @click="btnClick('00')">
            待上架({{ numView.waitPutawayNum || 0 }}台)
          </div>
          <div :class="auditStatus === '05' ? 'active' : 'none'" @click="btnClick('05')">
            已售出({{ numView.sellBeenNum || 0 }}台)
          </div>
          <div :class="auditStatus === '07' ? 'active' : 'none'" @click="btnClick('07')">
            已提货({{ numView.pickUpNum || 0 }}台)
          </div>
          <div :class="auditStatus === '10' ? 'active' : 'none'" @click="btnClick('10')">
            已下市({{ numView.delistingNum || 0 }}台)
          </div>
        </div>
      </div>
    </div>
    <div v-if="seachDataList.length">
      <div v-for="(item, index) in seachDataList" style="margin-bottom: 20px" :key="item.customerOrderNo">
        <div class="table_title">
          <div class="table_index">
            <div>{{ index + 1 }}</div>
          </div>
          <div class="sell_storeType">
            <div>{{ item.catalog == '00' ? "优品机" : item.catalog == '01' ? "演示机" : "资源机" }}</div>
          </div>
          <div class="table_orderNo" style="margin-left: 5px;">
            <div>{{ item.productName }}</div>
          </div>
          <div class="table_orderNo" style="margin-left: 40px;">
            <div>商品编码：{{ item.productCode }}</div>
          </div>
          <div class="table_copy" @click="copyValue(item.productCode)">
            复制
          </div>
          <div :class="{'sell_storeType':!item.isTransferStore ,'sell_diao':item.isTransferStore}">
            <div>{{ item.isTransferStore	? "可调店" : "不可调店" }}</div>
          </div>
          <div class="table_storeType2">
            <div style="margin-right: 8px;">浏览量： <span style="color: #0981FF">{{ item.visitNum }}</span></div>
            <div style="cursor: pointer;" @click="seeRemark(item)">分享浏览用户：<span style="color: #0981FF">{{ item.shareNum
            }}</span></div>
          </div>
        </div>
        <div class="table_list">
          <el-table ref="tableGroup" :highlight-current-row="true" stripe :data="[item]" size="small" border
            style="width: 100%">
            <el-table-column prop="imageList" label="旧机图片" align="center">
              <template slot-scope="{ row }">
                <img v-if="row.imageList" style="cursor: pointer;width: 60px;height: 70px;" :src="row.imageList[0].smallImg" alt=""
                  @click="staffDia(row)">
                <img v-else style="cursor: pointer;" src="http://img.fanxinghuishou.cn/20230418/075263776.png" alt="">
              </template>
            </el-table-column>
            <el-table-column prop="machineName" label="机型名称" align="center">
            </el-table-column>
            <el-table-column prop="imei" label="旧机串号" align="center">
            </el-table-column>
            <el-table-column prop="typeName" label="所属分类" align="center">
            </el-table-column>
            <el-table-column prop="brandName" label="品牌" align="center">
            </el-table-column>
            <el-table-column prop="fineness" label="成色" align="center">
            </el-table-column>
            <el-table-column prop="cost" label="成本价" align="center">
              <template slot-scope="{ row }">
                <span>￥{{ row.cost || "--" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sellPrice" label="销售价" align="center">
              <template slot-scope="{ row }">
                <span>￥{{ row.sellPrice || "--" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="named" label="质检报告" align="center">
              <template slot-scope="{ row }">
                <span style="cursor: pointer;text-decoration:underline;color:#0981ff;" @click="checkReport(row)">查看</span>
              </template>
            </el-table-column>
            <el-table-column prop="createStaffName" label="添加人" align="center" width="100">
              <template slot-scope="{ row }">
                <div>{{ row.createStaffName }}-{{ row.createStaffPhone }}</div>
                <el-button type="success" size="small">{{ row.createStaffIsMajor
                  ? "创建人"
                  : row.createStaffType == "01"
                    ? "子账号"
                    : row.createStaffType == "02"
                      ? "总监"
                      : row.createStaffType == "03"
                        ? "店长"
                        : "店员" }}</el-button>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" align="center">
              <template slot-scope="{ row }">
                <span style="text-align: center">{{ row.createTime || "--" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="putawayStaffName" label="上架操作人" align="center">
              <template slot-scope="{ row }">
                <span>{{ row.putawayStaffName }}-{{ row.putawayPhone || "-" }}</span>
              </template>
            </el-table-column>
            <el-table-column label="最近上架时间" align="center">
              <template slot-scope="{ row }">
                <span style="text-align: center">{{ row.putawayTimeLast || "--" }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="stockStoreName" label="库存位置" align="center">
              <template slot-scope="{ row }">
                <span>{{ row.stockStoreName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="state" label="商品状态" align="center">
              <template slot-scope="{ row }">
                <span>{{
                  row.state == '00' ? '待上架' : row.state == '03' ? '售卖中' : row.state == '05' ? '已售出' : row.state == '07' ?
                    '已提货' : '已下市'
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="200">
              <template slot-scope="{ row }">
                <div class="action_style">
                  <el-button size="small" type="primary" @click="acReport(row)">操作记录</el-button>
                  <el-button v-if="row.state !== '10' && row.state !== '07'" size="small" type="warning"
                    @click="economAction(row)">调库</el-button>
                  <el-button v-if="row.state === '00'" size="small" type="success"
                    @click="grounding(row, 1)">上架</el-button>
                  <el-button v-if="row.state === '00' || row.state === '03'" size="small" type="info"
                    @click="grounding(row, 2)">下市</el-button>
                  <el-button v-if="row.state === '03'" size="small" type="danger"
                    @click="grounding(row, 3)">下架</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div v-else class="emptyStyle">
      暂无订单~
    </div>
    <div class="orderPagina">
      <el-pagination background :current-page="page.pageNum" :page-size="page.pageSize"
        layout="total, prev, pager, next,jumper" :total="page.total" class="el-pagination-c"
        @current-change="handleCurrentChange" />
    </div>
    <!-- 查看分享浏览用户 -->
    <el-dialog title="分享浏览用户" :visible.sync="shareVisible" :close-on-click-modal="false" width="1000px">
      <!-- 查询 -->
      <el-form :inline="true" size="small">
        <el-form-item class="el_from" label="门店名称" style="margin: 0" label-width="70px">
          <el-select v-model="shareStoreId" placeholder="请输入或选择门店名称" filterable clearable>
            <el-option v-for="item in stmoreList" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="el_from" label="手机号：" label-width="80px">
          <el-input v-model.trim="UserPhone" placeholder="请输入手机号" clearable></el-input>
        </el-form-item>
        <el-form-item class="el_from" label="姓名：">
          <el-input v-model.trim="outUserName" placeholder="请输入姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getcommSharelist()">查询</el-button>
        </el-form-item>
      </el-form>
      <!-- 表格 -->
      <GlobalTable ref="GlobalTable" :columns="shareColumns" v-loading="shareLoading" :data="shareTableData"
        :currentPage="page2.pageNum" :total="page2.total" :pageSize="page2.pageSize"
        @handleCurrentChange="getcommSharelist">
        <el-table-column slot="headImg" label="顾客头像" align="center">
          <template slot-scope="{ row }">
            <img style="cursor: pointer;width: 60px; border-radius: 50%;" :src="row.headImg" alt="">
          </template>
        </el-table-column>
        <el-table-column slot="userName" label="浏览顾客" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.userName }}-{{ row.userPhone }}</span>
          </template>
        </el-table-column>
        <el-table-column slot="shareStaffName" label="分享店员" align="center" width="200">
          <template slot-scope="{ row }">
            <div>{{ row.shareStaffName }}-{{ row.shareStaffPhone }}</div>
            <el-button type="success" size="small">{{ row.shareStaffIsMajor
              ? "创建人"
              : row.shareStaffType == "01"
                ? "子账号"
                : row.shareStaffType == "02"
                  ? "总监"
                  : row.shareStaffType == "03"
                    ? "店长"
                    : "店员" }}</el-button>
          </template>
        </el-table-column>
      </GlobalTable>
      <span slot="footer" class="dialog-footer">
        <el-button plain @click.native="shareVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 操作记录 -->
    <el-dialog title="操作记录" :visible.sync="operatShow" :close-on-click-modal="false" width="800px" @close="closeOreport">
      <div class="button_top">
        <div class="radiobtn">
          <div class="faultBtn">
            <div :class="recordAction === 1 ? 'active' : 'none'" @click="recoderClick(1)">
              上下架记录
            </div>
            <div :class="recordAction === 2 ? 'active' : 'none'" @click="recoderClick(2)">
              调库记录
            </div>
          </div>
        </div>
      </div>
      <GlobalTable ref="GlobalTable" :pageSizes="[5, 10, 50, 100]" :columns="oerpotColumns" v-loading="oerpotLoading"
        :data="oerpotTableData" :currentPage="rapage.pageNum" :total="rapage.total" :pageSize="rapage.pageSize"
        @handleCurrentChange="getoptList">
        <el-table-column slot="createTime" :label="recordAction == 1 ? '操作时间' : '调拨时间'" align="center">
          <template slot-scope="{ row }">
            <div>{{ row.createTime || "--" }}</div>
          </template>
        </el-table-column>
        <el-table-column slot="createStaffName" label="操作人" align="center">
          <template slot-scope="{ row }">
            <div>{{ row.createStaffName }}-{{ row.createStaffPhone }}</div>
          </template>
        </el-table-column>
        <el-table-column slot="optType" v-if="recordAction == 1" label="操作事件" align="center">
          <template slot-scope="{ row }">
            <div>{{ row.optType == 'up' ? '上架' : row.optType == 'down' ? '下架' : '下市' }}</div>
          </template>
        </el-table-column>
        <el-table-column slot="outStoreName" v-if="recordAction == 2" label="调出门店" align="center">
          <template slot-scope="{ row }">
            <div>{{ row.outStoreName }}</div>
          </template>
        </el-table-column>
        <el-table-column slot="inStoreName" v-if="recordAction == 2" label="调入门店" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.inStoreName }}</span>
          </template>
        </el-table-column>
      </GlobalTable>
      <span slot="footer" class="dialog-footer">
        <el-button plain @click.native="closeOreport">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 质检报告 -->
    <el-dialog title="质检报告" :visible.sync="nonsalableVisible" :close-on-click-modal="false" width="800px"
      @closed="nonsalableVisible = false">
      <div class="re_top" >
        <div class="reline"></div>
        <span>基本信息</span>
      </div>
      <div class="re_content">
        <div class="rec_revol" v-for="(i,index) in dereportList.bases" :key="index">
          <span>{{ i.label }}：</span>
          <span v-if="i.layout=='01'">
            <span v-for="ivue in i.values" :key="ivue.value"  style="color: rgb(9, 129, 255);">
           <span v-if="ivue.isSelected"> {{ ivue.value }}</span>
          </span>
          </span>
           <span v-else style="color: rgb(9, 129, 255);">{{ i.values[0].value }}</span>
        </div>
      </div>
      <div class="re_top">
        <div class="reline"></div>
        <span>成色情况</span>
      </div>
      <div class="re_content">
        <div class="rec_revol" v-for="(i,index) in dereportList.fineness" :key="index">
          <span>{{ i.label }}：</span>
          <span v-for="ivue in i.values" :key="ivue.value"  style="color: rgb(9, 129, 255);">
           <span v-if="ivue.isSelected"> {{ ivue.value }}</span>
          </span>
        </div>
      </div>
      <div class="re_top">
        <div class="reline"></div>
        <span>功能情况</span>
      </div>
      <div class="re_content">
        <div class="rec_revol" v-for="(i,index) in dereportList.func" :key="index">
          <span>{{ i.label }}：</span>
          <span v-for="ivue in i.values" :key="ivue.value"  style="color: rgb(9, 129, 255);">
           <span v-if="ivue.isSelected"> {{ ivue.value }}</span>
          </span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small"  @click="nonsalableVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 调库 -->
    <el-dialog title="调库" :visible.sync="delDialogVisible" :close-on-click-modal="false" width="500px"
      @closed="delDialogVisible = false">
      <div class="mb-20"><span>当前库存位置：</span>{{ stockStoreName }}</div>
      <el-form ref="form" label-width="80px">
        <el-form-item class="el_from" label="选择调往位置" style="margin: 0" label-width="100px">
          <el-select v-model="dispatchStoreId" placeholder="请输入或选择调往位置" filterable clearable>
            <el-option v-for="item in dispatchList" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button plain @click.native="delDialogVisible = false">关闭</el-button>
        <el-button size="small" :loading="isDispatch" type="primary" @click="suredelDialog">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 上下架提示 -->
    <el-dialog @close="closeall" :title="Removal" :visible.sync="estiPriceDialog" :close-on-click-modal="false"
      width="400px">
      <div class="fzs16 texleft mb20">说明：{{
        isallType == 1 ? '上架后商品将展示在C端小程序，顾客可预约购买，如商品在线下售出需及时下架或下市。' : isallType == 2 ? '下市后，不可再次上架售卖。' : '下架后可重新编辑后上架。' }}
      </div>
      <div class="rv_center">
        {{ isallType == 1 ? '是否确认上架该商品？' : isallType == 2 ? '是否确认商品下市？' : '是否确认商品下架？' }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click.native="closeall">关闭</el-button>
        <el-button size="small" :loading="allloding" type="primary" @click="allFrame">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="退回原因" :visible.sync="refundTimeDialog" :close-on-click-modal="false" width="400px"
      @closed="refundTimeDialog = false">
      <div class="mb-20">{{ refundTimeText }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="refundTimeDialog = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 查看旧机图片 -->
    <el-dialog :close-on-click-modal="false" :width="`${800}px`" title="查看旧机图片" :visible="imgShow" @close="imgClose"
      top="5%">
      <div class="img-box">
        <div class="img-tips-box">
          <div class="img-tips" :class="imgShowOnly ? 'img-tips-choose' : 'img-tips-default'">
            旧机图片
          </div>
        </div>
        <div class="img-show">
          <div class="imgs-num" v-if="DialogImgList.length > 0">
            {{ imgShowIndex + 1 }}/{{ DialogImgList.length }}
          </div>
          <div class="block">
            <viewer :images="DialogImgList">
              <el-carousel trigger="click" height="80vh" @change="getindex">
                <el-carousel-item v-for="(item, index) in DialogImgList" :key="index">
                  <div class="sec_img">
                    <img :src="item.originalImg" alt="" />
                  </div>
                </el-carousel-item>
              </el-carousel>
            </viewer>
          </div>
          <!-- <LookImg :images="imgList"/> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";

export default {
  name: "Table",
  data() {
    return {
      allloding: false,
      Removal: "下架提示",
      storeList: [],
      dispatchList: [],
      stmoreList: [],
      isDispatch: false,
      auditStatus: null,
      recordAction: 1,
      dispatchStoreId: "",
      numView: {
        allNum: 0,
        delistingNum: 0,
        sellBeenNum: 0,
        sellingNum: 0,
        pickUpNum: 0,
        waitPutawayNum: 0,
      },
      // 操作记录
      operatShow: false,
      addRemarksTxt: '',
      // 查看备注
      productCode: null,
      shareVisible: false,
      shareTableData: [],
      oerpotTableData: [],
      page2: {
        pageNum: 1,
        pageSize: 5,
        total: 0,
      },
      //操作记录
      oerpotColumns: [
        { slotName: "createTime" },
        { slotName: "createStaffName" },
        { slotName: "optType" },
        { slotName: "outStoreName" },
        { slotName: "inStoreName" },
      ],
      shareColumns: [
        { slotName: "headImg" },
        { slotName: "userName" },
        { slotName: "shareStaffName" },
        { label: "所属门店", prop: "storeName" },
        { label: "浏览时间", prop: "createTime" },
      ],
      outUserName: '',//备注人-查询
      UserPhone: '',//电话-查询
      shareStoreId: "",
      shareLoading: false,
      oerpotLoading: false,
      nonsalableVisible: false,//质检报告
      estiPriceDialog: false,//下架下市弹框
      seachDataList: [],
      dialogVisible: false,
      imgShow: false,
      imgShowOnly: true,
      DialogImgList: [],
      imgShowIndex: 0,
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      //操作记录
      rapage: {
        pageNum: 1,
        pageSize: 5,
        total: 0,
      },
      isallType: null,
      demmachineStoreList:[],
      stockStoreId: "",
      stockStoreName: "",
      delDialogVisible: false,
      commentId: "",
      CancelCauseText: "",
      refundTimeDialog: false,
      refundTimeText: "",
      dereportList: {}
    };
  },
  created() {
    this.handleCurrentChange();
    this.getAllStoreSelectList()
    this.getAllStoreSelectListOnline()
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
  },
  watch: {
    SeachParams(newVal) {
      console.log(newVal);
      this.page.pageNum = 1;
      this.handleCurrentChange();
    },
    "modelform.merchantId"(val) {
      if (!val) {
        this.modelform.companyId = "";
      }
    },
  },
  methods: {
    //质检报告
    checkReport(row) {
      _api.delireport({ productCode: row.productCode }).then(res => {
        if (res.code == 1) {
          this.dereportList = res.data
          this.nonsalableVisible=true
        }
      })
    },
    //获取调库
    getAllStoreSelectListOnline(){
      this.demmachineStoreList = []
      _api.getAllStoreSelectListOnline().then(res => {
        if (res.code == 1) {
          this.demmachineStoreList = JSON.parse(JSON.stringify(res.data))
          this.demmachineStoreList.unshift({
            isEnable: true,
            key: "-1",
            value: "公司总部",
          })
        }
      })
    },
    // 获取全部门店
    getAllStoreSelectList() {
      this.storeList = []
      _api.getAllStoreSelectList().then(res => {
        if (res.code == 1) {
          this.storeList = JSON.parse(JSON.stringify(res.data))
          this.stmoreList = JSON.parse(JSON.stringify(res.data))
          this.storeList.unshift({
            isEnable: true,
            key: "-1",
            value: "公司总部",
          })
        }
      })
    },
    // 获取分享列表
    getcommSharelist(val) {
      if (val) {
        this.page2.pageNum = val;
      }
      const baseRequest = {
        userName: this.outUserName,
        userPhone: this.UserPhone,
        storeId: this.shareStoreId,
        productCode: this.productCode,
        pageNum: this.page2.pageNum,
        pageSize: this.page2.pageSize,
      };
      this.shareLoading = true
      _api.commSharelist(baseRequest).then(res => {
        if (res.code == 1) {
          this.shareTableData = res.data.records;
          this.page2.total = res.data.total;
          this.page2.pageSize = res.data.size;
          this.page2.pageNum = res.data.current;
          this.shareLoading = false
        } else {
          this.shareLoading = false
        }
      })
    },
    btnClick(type) {
      this.auditStatus = type
      this.rapage.pageNum = 1
      this.handleCurrentChange()
    },
    //关闭操作记录
    closeOreport() {
      this.operatShow = false
      this.productCode = ""
      this.recordAction = 1
      this.rapage.pageNum = 1
    },
    //操作记录
    acReport(row) {
      this.productCode = row.productCode
      this.operatShow = true
      this.rapage.pageNum = 1
      this.recordAction = 1
      this.getoptList()
    },
    //操作记录和调库记录切换
    recoderClick(num) {
      this.rapage.pageNum = 1
      this.recordAction = num
      this.getoptList()
    },
    //获取上下架操作记录
    getoptList(val) {
      if (val) {
        this.rapage.pageNum = val;
      }
      const baseRequest = {
        productCode: this.productCode,
        pageNum: this.rapage.pageNum,
        pageSize: this.rapage.pageSize,
      };
      this.oerpotLoading = true
      if (this.recordAction == 1) {
        //上下架纪录
        _api.optList(baseRequest).then(res => {
          if (res.code == 1) {
            this.oerpotTableData = res.data.records;
            this.rapage.total = res.data.total;
            this.rapage.pageNum = res.data.current;
            this.rapage.pageSize = res.data.size;
            this.oerpotLoading = false
          } else {
            this.oerpotLoading = false
          }
        })
      } else {
        // 调库记录
        _api.stockList(baseRequest).then(res => {
          if (res.code == 1) {
            this.oerpotTableData = res.data.records;
            this.rapage.total = res.data.total;
            this.rapage.pageSize = res.data.size;
            this.rapage.pageNum = res.data.current;
            this.oerpotLoading = false
          } else {
            this.oerpotLoading = false
          }
        })
      }
    },
    // 查看分享浏览用户
    seeRemark(row) {
      this.outUserName = ''
      this.UserPhone = ""
      this.shareStoreId = ""
      this.page2.pageNum = 1
      this.page2.pageSize = 5
      this.productCode = row.productCode;
      this.getcommSharelist()
      this.shareVisible = true
    },
    //
    getindex(e) {
      console.log(e);
      this.imgShowIndex = e;
    },
    //调库
    economAction(row) {
      this.stockStoreName = row.stockStoreName
      this.productCode = row.productCode
      this.dispatchStoreId = ""
      this.delDialogVisible = true
      this.dispatchList = this.demmachineStoreList.filter(item => {
        return item.key != row.stockStoreId
      })
    },
    //确定调库
    suredelDialog() {
      if (this.dispatchStoreId) {
        this.isDispatch = true
        _api.transferStore({
          productCode: this.productCode,
          stockStoreId: this.dispatchStoreId
        }).then(res => {
          if (res.code == 1) {
            this.delDialogVisible = false;
            this.productCode = "";
            this.$message({
              message: '调库成功！',
              type: 'success'
            });
            this.handleCurrentChange();
          }
          this.isDispatch = false
        }).catch(err => {
          this.isDispatch = false
        })
      } else {
        this.$message.error('请选择调往位置！');
      }
    },
    //上下架，下市
    grounding(row, num) {
      this.productCode = row.productCode
      this.isallType = num
      this.estiPriceDialog = true
      if (num == 1) {
        //上架
        this.Removal = "上架提示"
      } else if (num == 2) {
        //下市
        this.Removal = "下市提示"
      } else {
        //下架
        this.Removal = "下架提示"
      }
    },
    //上下架，下市关闭
    closeall() {
      this.productCode = ""
      this.estiPriceDialog = false
    },
    //上下架，下市确定
    allFrame() {
      this.allloding = true
      if (this.isallType == 1) {
        //上架
        _api.soldIn({ productCode: this.productCode }).then(res => {
          if (res.code == 1) {
            this.estiPriceDialog = false
            this.handleCurrentChange();
            this.$message({
              message: '上架成功！',
              type: 'success'
            });
          }
        })
      } else if (this.isallType == 2) {
        //下市
        this.Removal = "下市提示"
        _api.delisting({ productCode: this.productCode }).then(res => {
          if (res.code == 1) {
            this.estiPriceDialog = false
            this.handleCurrentChange();
            this.$message({
              message: '下市成功！',
              type: 'success'
            });
          }
        })
      } else {
        //下架
        this.Removal = "下架提示"
        _api.soldOut({ productCode: this.productCode }).then(res => {
          if (res.code == 1) {
            this.estiPriceDialog = false
            this.handleCurrentChange();
            this.$message({
              message: '下架成功！',
              type: 'success'
            });
          }
        })
      }
      this.allloding = false
    },
    //详情
    jumDetal(row) {
      let lybl = this.$router.resolve(
        {
          path: '/onlinSalemachines/Saleorderdetails',
          query: {
            buyOrderNo: row.buyOrderNo
          }
        })

      window.open(lybl.href, '_blank');
    },
    //详情
    reportDetal(row) {
      let lybl = this.$router.resolve(
        {
          path: '/conbuyManage/inspectionReport',
          query: {
            buyOrderNo: row.buyOrderNo,
            qcCode: row.qcCode
          }
        })

      window.open(lybl.href, '_blank');
    },
    //查看图片
    staffDia(row) {
      if (row.imageList) {
        this.imgShow = true;
        this.DialogImgList = row.imageList;
        console.log(this.DialogImgList);
      }
    },
    imgClose() {
      console.log(1);
      this.imgShow = false;
      this.imgList = [];
    },
    // 复制
    copyValue(context) {
      // 创建输入框元素
      let oInput = document.createElement("input");
      // 将想要复制的值
      oInput.value = context;
      // 页面底部追加输入框
      document.body.appendChild(oInput);
      // 选中输入框
      oInput.select();
      // 执行浏览器复制命令
      document.execCommand("Copy");
      // 弹出复制成功信息
      this.$message.success("复制成功");
      // 复制后移除输入框
      oInput.remove();
    },
    // 表格切换页面
    handleCurrentChange(val) {
      console.log("表格切换页面", val);
      if (val) {
        this.page.pageNum = val;
      } else {
        this.page.pageNum = 1;
      }
      const params = {
        catalog: this.SeachParams.catalog,
        isTransferStore: this.SeachParams.isTransferStore,
        stockStoreId: this.SeachParams.stockStoreId,
        productCode: this.SeachParams.productCode,
        endTimeCreate: this.SeachParams.endTimeCreate,
        startTimeCreate: this.SeachParams.startTimeCreate,
        endTimePutawayLast: this.SeachParams.endTimePutawayLast,
        startTimePutawayLast: this.SeachParams.startTimePutawayLast,
        machineName: this.SeachParams.machineName,
        productName: this.SeachParams.productName,
        imei: this.SeachParams.imei,
        state: this.auditStatus,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      this.loading = true;
      _api.commodityList(params).then((res) => {
        if (res.code === 1) {
          this.seachDataList = res.data.list.records;
          this.page.total = res.data.list.total;
          this.page.pageNum = res.data.list.current;
          this.loading = false;
          this.numView.allNum = res.data.allNum
          this.numView.pickUpNum = res.data.pickUpNum
          this.numView.delistingNum = res.data.delistingNum
          this.numView.sellBeenNum = res.data.sellBeenNum
          this.numView.sellingNum = res.data.sellingNum
          this.numView.waitPutawayNum = res.data.waitPutawayNum
        }
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
        this.loading = false;
      }).catch(() => {
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.re_top {
  display: flex;
  align-items: center;

  .reline {
    width: 4px;
    height: 16px;
    background: #4966d2;
    margin-bottom: 0px;
    margin-right: 10px;
  }
}

.re_content {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  .rec_revol {
    width: 370px;
    height: 40px;
    background-color: #e4ecfd;
    border-radius: 5px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    margin-bottom: 10px;
    color: #333333;
    font-size: 14px;
    margin-right: 10px;
    word-break: break-all;
  }
}

.action_style {
  /deep/.el-button {
    margin-right: 5;
    margin-bottom: 5px;
  }
}

.emptyStyle {
  width: 100%;
  text-align: center;
  padding: 80px 0;
  font-size: 24px;
  color: #666666;
  background: white;
  font-weight: bold;
}

.button_top {
  margin-bottom: 20px;
  ;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.faultBtn {
  // min-width: 500px;
  height: 34px;
  background: #F9FBFD;
  border: 1px solid #C1D1FF;
  box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
  border-radius: 21px;
  display: flex;
  cursor: pointer;

  .active {
    text-align: center;
    color: white;
    // width: 50%;
    height: 14px;
    padding: 0 15px;
    font-size: 14px;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    line-height: 32px;
    height: 32px;
    background: #0981FF;
    border-radius: 20px;
  }

  .none {
    text-align: center;
    color: #333;
    // width: 50%;
    padding: 0 15px;
    height: 14px;
    font-size: 14px;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    line-height: 32px;
    height: 32px;
    border-radius: 20px;
  }
}

.color1 {
  color: #0981FF;
}

.color2 {
  color: #F83232;
}

.type03 {
  margin-top: 6px;
  color: #999;
  padding: 8px;
  border-radius: 4px;
  background-color: #F2F2F2;
}

.exStitle {
  margin-bottom: 15px;
  color: #ff8080;
  font-size: 14px;
}

.enable_tip {
  width: 460px;
  display: flex;
  flex-wrap: wrap;

  >div {
    width: 210px;
    margin: 0 20px 20px 0;
    font-weight: bold;
  }

}

.cblue {
  color: #0981FF;
}

.est_box {
  padding-left: 20px;
}

.middle_box {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: #eee;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  border-radius: 4px;
}

.fzs16 {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
}

.rv_center {
  font-size: 14px;
  text-align: center;
  margin-bottom: 10px;
}

.fzs14 {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
}

.non-sales-item {
  width: 340px;
  // height: 40px;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 6px;
  background-color: #F2F2F2;
  color: #F83232;
}

.mb10 {
  margin-bottom: 10px;
}

.mb20 {
  margin-bottom: 20px;
}

.mb30 {
  margin-bottom: 30px;
}

.texleft {
  text-align: left;
  color: #f83232;
}

.tableBtnUn {
  color: #0981ff;
  cursor: pointer;
  text-decoration: underline;
}

.colocah {
  text-align: center;
  color: #0981ff;
}

.img-box {
  margin-bottom: 20px;

  // 图片
  .imgs-num {
    text-align: center;
    margin: 5px 0;
    font-weight: bold;
  }

  .img-tips-box {
    display: flex;
    height: 30px;
    width: max-content;
    border: 1px solid #0981ff;

    .img-tips {
      width: 80px;
      text-align: center;
      line-height: 30px;
      box-sizing: border-box;
      cursor: pointer;
    }

    .img-tips-default {
      background: #fff;
      color: #0981ff;
    }

    .img-tips-choose {
      background: #0981ff;
      color: #fff;
    }
  }

  .sec_img {
    width: 20vw;
    height: 80vh;
    margin: auto;

    img {
      width: 20vw;
      height: 80vh;
      object-fit: contain;
    }
  }

  // 列表
}

.GlobalTable {

  // 查看明细详情
  .settlement_detail {
    width: 100%;

    >h2 {
      font-size: 14px;
      color: #308BFB;
      margin-bottom: 20px;
      font-weight: 900;
    }

    >div {
      width: 100%;
      background: #f5f6fa;
      border-radius: 6px;
      padding: 12px;
      box-sizing: border-box;
      margin-bottom: 20px;

      >h3 {
        font-size: 14px;
        color: #2384FB;
        padding-left: 12px;
        line-height: 14px;
        position: relative;

        &::after {
          content: "";
          background: #2384FC;
          display: block;
          position: absolute;
          left: 0;
          top: 1px;
          width: 4px;
          border-radius: 2px;
          height: 12px;
        }
      }

      >div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;
        padding-left: 10px;

        >p:first-of-type {
          color: #F80000;
        }
      }
    }
  }

  .table_title {
    position: relative;
    display: flex;
    height: 40px;
    padding: 10px 0;
    align-items: center;
    background: #F4F6F9;
    border-radius: 6px 6px 0px 0px;
  }

  .table_index {
    background: #fcba05;
    height: 20px;
    padding: 0 10px;
    color: #fff;
    text-align: center;
    line-height: 20px;
    border-radius: 3px 10px 10px 3px;
    margin-left: -5px;
  }

  .table_storeType {
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgb(248, 50, 50);
    border-radius: 5px;
    color: rgb(248, 50, 50);
    font-size: 12px;
    padding: 3px 5px;
    position: absolute;
    right: 20px;
  }

  .sell_storeType {
    margin-left: 10px;
    border-radius: 20px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid rgb(248, 50, 50);
    color: rgb(248, 50, 50);
    font-size: 12px;
    padding: 3px 5px;
  }
  .sell_diao {
    margin-left: 10px;
    border-radius: 20px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border:1px solid #80C269;
    color: #80C269;
    font-size: 12px;
    padding: 3px 5px;
  }

  .sell_storeType2 {
    background-color: #fff;
    position: absolute;
    right: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #0981ff;
    border-radius: 5px;
    color: #0981ff;
    font-size: 12px;
    padding: 3px 5px;
  }

  .table_storeType2 {
    position: absolute;
    right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    font-size: 12px;
    padding: 3px 5px;
  }

  .table_orderNo {
    // color: #0981ff;
    font-size: 14px;
    margin-left: 20px;
    padding: 0 5px;
  }

  .table_copy {
    cursor: pointer;
    color: #fff;
    text-align: center;
    line-height: 20px;
    margin-left: 10px;
    border-radius: 5px;
    font-size: 12px;
    padding: 0 5px;
    background: #0981ff;
  }

  .red {
    color: red;
  }

  .green {
    color: #00b305;
  }

  .ccc {
    color: #707070;
  }

  .mt-20 {
    margin-top: 20px;
  }

  .mb-10 {
    margin-bottom: 10px;
  }

  .mb-20 {
    margin-bottom: 20px;
  }

  .mr-50 {
    margin-right: 50px;
  }

  .ml-10 {
    margin-left: 10px;
  }

  .mr-10 {
    margin-right: 10px;
  }

  .font-w {
    font-weight: bold;
  }

  .flex {
    display: flex;
    align-items: center;
  }

  .flex-jb {
    display: flex;
    justify-content: space-between;
  }

  .flex-as {
    display: flex;
    align-items: flex-start;
  }

  .flex-ja {
    display: flex;
    justify-content: space-around;
  }

  // 备注说明
  .Remarks {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }

  .images-box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .images-box>img {
    width: 70px;
    height: 70px;
    margin-bottom: 10px;
  }

  .images-box>span {
    color: #0981ff;
    cursor: pointer;
  }

  .textdown {
    color: #0981ff;
    text-decoration: underline;
  }

  .orderPagina {
    float: right;
    margin: 50px;
  }
}</style>
